
export default (data) => ({
  json: data?.html?.json ?? null,
})
